
import React, { useEffect, useRef, useState } from "react";
import { Table, Form, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CompaniesHeader from '../../../components/crm/companies/CompaniesHeader'
import { FaCalendarAlt } from "react-icons/fa";
import {
  FaEye,
  FaStar,
  FaEnvelope,
  FaPhone,
  FaComment,
  FaSkype,
  FaFacebook,
} from "react-icons/fa";
import listheader from '../../../assets/css/listheader.css'
import BrightWave from "../../../assets/img/company/company-01.svg";
import Stellar from "../../../assets/img/company/company-02.svg";
import NovaTech from "../../../assets/img/company/company-03.svg";
import Quantum from "../../../assets/img/company/company-04.svg";
import Skyline from "../../../assets/img/company/company-05.svg";
import NextGen from "../../../assets/img/company/company-06.svg";
import AlphaEdge from "../../../assets/img/company/company-07.svg";
import Zenith from "../../../assets/img/company/company-08.svg";
import AddCompaniesModal from "../../../components/modals/crm/companies/add-companies/AddCompaniesModal";


// 👉 Sample Data (replace with your assets)


const companyData = [
  {
    id: 1,
    name: "BrightWave Innovations",
    img: BrightWave,
    email: "brightwave@example.com",
    phone: "(163) 2459 315",
    location: "Germany",
    rating: 4.2,
    owner: "Hendry Milner",
    status: "Active",
  },
  {
    id: 2,
    name: "Stellar Dynamics",
    img: Stellar,
    email: "stellar@example.com",
    phone: "(146) 1249 296",
    location: "USA",
    rating: 5.0,
    owner: "Guilory Berggren",
    status: "Active",
  },
  {
    id: 3,
    name: "NovaTech Solutions",
    img: NovaTech,
    email: "nova@example.com",
    phone: "(198) 5678 123",
    location: "India",
    rating: 4.5,
    owner: "Rahul Verma",
    status: "Inactive",
  },
  {
    id: 4,
    name: "Quantum Corp",
    img: Quantum,
    email: "quantum@example.com",
    phone: "(187) 3456 789",
    location: "UK",
    rating: 4.8,
    owner: "James Smith",
    status: "Active",
  },
  {
    id: 5,
    name: "Skyline Tech",
    img: Skyline,
    email: "skyline@example.com",
    phone: "(176) 2222 333",
    location: "Canada",
    rating: 4.1,
    owner: "Sophia Lee",
    status: "Inactive",
  },
  {
    id: 6,
    name: "NextGen Systems",
    img: NextGen,
    email: "nextgen@example.com",
    phone: "(165) 9876 543",
    location: "Australia",
    rating: 4.7,
    owner: "Liam Brown",
    status: "Active",
  },
  {
    id: 7,
    name: "AlphaEdge Pvt Ltd",
    img: AlphaEdge,
    email: "alpha@example.com",
    phone: "(154) 4567 890",
    location: "Singapore",
    rating: 4.3,
    owner: "Arjun Rao",
    status: "Active",
  },
  {
    id: 8,
    name: "Zenith Labs",
    img: Zenith,
    email: "zenith@example.com",
    phone: "(143) 1122 334",
    location: "France",
    rating: 4.6,
    owner: "Emma Watson",
    status: "Inactive",
  },
];
const CompaniesListPage = () => {

   const[Company,setCompany]=useState(false)
  
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);

  // 🔍 Search Filter
  const filteredData = companyData.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

// list-header

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Last 7 Days");
  const [range, setRange] = useState("04/09/2026 - 04/15/2026");

  const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];

  const handleSelect = (item) => {
    setSelected(item);
    setOpen(false);

    // 🔥 Dummy dynamic update (you can connect API here)
    if (item === "Today") setRange("04/15/2026 - 04/15/2026");
    else if (item === "Yesterday") setRange("04/14/2026 - 04/14/2026");
    else if (item === "Last 7 Days") setRange("04/09/2026 - 04/15/2026");
    else if (item === "Last 30 Days") setRange("03/16/2026 - 04/15/2026");
    else if (item === "This Year") setRange("01/01/2026 - 12/31/2026");
    else if (item === "Next Year") setRange("01/01/2027 - 12/31/2027");
  };

//  company
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("Company");
  const dropdownRef = useRef();

  const companyList = [
    "BrightWave Innovations",
    "Quantum Nexus",
    "TerraFusion Energy",
    "Skyline Tech",
    "NextGen Solutions"
  ];

  // Toggle dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };



  // Select company
  const handleSelectCompany = (company) => {
    setSelectedCompany(company);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  // status
   const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("Select Status");
  const statusRef = useRef();

  const statusOptions = ["Active", "Inactive"];

  // Toggle dropdown
  const toggleStatusDropdown = () => {
    setIsStatusOpen(!isStatusOpen);
  };

  // Select status
    const [showList, setShowList] = useState(false);
  const [currentText, setCurrentText] = useState("Select Status");



  // sort-by

    const [openBox, setOpenBox] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Last 7 Days");


  return (
   <div>
     <Card style={{ padding: "15px", background: "#f8f9fa",  }} className="company-card">
     
      <CompaniesHeader openModal={() => setCompany(true)} title="Companies List"   />
      {/* Header */}
<Card.Header style={{backgroundColor:"#ffff"}} className="companies-header">

  {/* TOP ROW */}
  <div className="header-top">
    <h5 className="title">Companies List</h5>

    <div className="filters">
      
      {/* DATE */}
 <div className="date-filter-wrapper">
      {/* BOX */}
      <div className="filter-box" onClick={() => setOpen(!open)}>
        <FaCalendarAlt className="me-2" />
        {range}
      </div>

      {/* DROPDOWN */}
      {open && (
        <div className="date-dropdown">
          {options.map((item, i) => (
            <div
              key={i}
              className={`dropdown-item ${
                selected === item ? "active" : ""
              }`}
              onClick={() => handleSelect(item)}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>

      {/* COMPANY */}
    <div className="company-dropdown-wrapper" ref={dropdownRef}>
      
      {/* Dropdown Header */}
      <div className="company-dropdown-header" onClick={toggleDropdown}>
        {selectedCompany}
        <span className={`arrow-icon ${isOpen ? "rotate" : ""}`}>▾</span>
      </div>

      {/* Dropdown List */}
      {isOpen && (
        <div className="company-dropdown-list">
          {companyList.map((company, index) => (
            <div
              key={index}
              className="company-dropdown-item"
              onClick={() => handleSelectCompany(company)}
            >
              {company}
            </div>
          ))}
        </div>
      )}
    </div>

      {/* STATUS */}
  <div className="simple-box">
      <div
        className="simple-toggle"
        onClick={() => setShowList(!showList)}
      >
        {currentText} <span>▾</span>
      </div>

      {showList && (
        <div className="simple-menu">
          <div
            onClick={() => {
              setCurrentText("Active");
              setShowList(false);
            }}
          >
            Active
          </div>

          <div
            onClick={() => {
              setCurrentText("Inactive");
              setShowList(false);
            }}
          >
            Inactive
          </div>
        </div>
      )}
    </div>
      {/* SORT */}
    <div className="sort-wrap">
      <div
        className="sort-toggle"
        onClick={() => setOpenBox(!openBox)}
      >
        Sort By : {selectedSort} <span>▾</span>
      </div>

      {openBox && (
        <div className="sort-menu">
          <div onClick={() => { setSelectedSort("Recently Added"); setOpenBox(false); }}>
            Recently Added
          </div>

          <div onClick={() => { setSelectedSort("Ascending"); setOpenBox(false); }}>
            Ascending
          </div>

          <div onClick={() => { setSelectedSort("Descending"); setOpenBox(false); }}>
            Descending
          </div>

          <div onClick={() => { setSelectedSort("Last Month"); setOpenBox(false); }}>
            Last Month
          </div>

          <div onClick={() => { setSelectedSort("Last 7 Days"); setOpenBox(false); }}>
            Last 7 Days
          </div>
        </div>
      )}
    </div>

    </div>
  </div>

  {/* BOTTOM ROW */}
  <div className="header-bottom">
    
    <div className="entries">
      Row Per Page
      <select>
        <option>10</option>
        <option>25</option>
        <option>50</option>
      </select>
      Entries
    </div>

    <Form.Control
      type="text"
      placeholder="Search"
      className="search-box"
      onChange={(e) => setSearch(e.target.value)}
    />

  </div>

</Card.Header>

      {/* Row Controls */}
      {/* <div className="p-3 d-flex justify-content-between flex-wrap">
        <div>
          Row Per Page{" "}
          <Form.Select
            value={rows}
            onChange={(e) => setRows(e.target.value)}
            className="d-inline w-auto ms-2"
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
          </Form.Select>
        </div>
      </div> */}

      {/* Table */}
      <div className="table-responsive">
        <Table className="align-middle">
          <thead>
            <tr>
              <th></th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Location</th>
              <th>Rating</th>
              <th>Owner</th>
              <th>Contact</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {filteredData.slice(0, rows).map((item) => (
              <tr key={item.id}>
                <td>
                  <Form.Check />
                </td>

                {/* Company Name + Image */}
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <Link to="/company-details">
                      <img
                        src={item.img}
                        className="company-img"
                        alt=""
                      />
                    </Link>
                    <Link to="/company-details" className="company-name">
                      {item.name}
                    </Link>
                  </div>
                </td>

                <td>{item.email}</td>
                <td>{item.phone}</td>
                <td>{item.location}</td>

                {/* Rating */}
                <td>
                  <FaStar className="text-warning me-1" />
                  {item.rating}
                </td>

                <td>{item.owner}</td>

                {/* Contact Icons */}
                <td>
                  <div className="d-flex gap-2">
                    <FaEnvelope />
                    <FaPhone />
                    <FaComment />
                    <FaSkype />
                    <FaFacebook />
                  </div>
                </td>

                {/* Status */}
                <td>
                  <span
                    className={
                      item.status === "Active"
                        ? "badge bg-success"
                        : "badge bg-danger"
                    }
                  >
                    {item.status}
                  </span>
                </td>

                {/* Eye Link */}
                <td>
                  <Link to="/company-details">
                    <FaEye />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <AddCompaniesModal    show={Company}
  handleClose={() => setCompany(false)} />
      <style>
        {
          `
          .company-card {
  border-radius: 6px;
  border: 2px solid #eee;
}

.company-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #ddd;
  padding: 5px;
  background: #fff;
}

.company-name {
  font-weight: 600;
  color: #000;
  text-decoration: none;
}

.company-name:hover {
  color: #0d6efd;
}

.search-box {
  width: 200px;
}

.table th {
  font-weight: 600;
  font-size: 14px;
}

.table td {
  font-size: 14px;
  vertical-align: middle;
}

/* Responsive */
@media (max-width: 768px) {
  .search-box {
    width: 100%;
  }
}
  // header

  .companies-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

/* TOP */
.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.title {
  font-size: 19px;
  font-weight: 620;
  color: #15171c;
}

/* FILTERS */
.filters {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-box {
  border: 1px solid #e5e7eb;
  padding: 12px 14px;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.filter-box span {
  font-size: 12px;
}

/* BOTTOM */
.header-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
  flex-wrap: wrap;
  gap: 10px;
}

/* ENTRIES */
.entries {
  font-size: 14px;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}

.entries select {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px 8px;
  outline: none;
}

/* SEARCH */
.search-box {
  width: 220px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  padding: 6px 12px;
}

/* MOBILE */
@media (max-width: 768px) {

  .header-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .filters {
    width: 100%;
    flex-wrap: wrap;
  }

  .filter-box {
    flex: 1 1 calc(50% - 6px);
    justify-content: space-between;
  }

  .header-bottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-box {
    width: 100%;
  }
}
`
        }
      </style>
    </Card>
   </div>
  );
};

export default CompaniesListPage;
